import { ArrowLeft02Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { IconButton } from '@pique/component';
import { usePostAugmentationTour } from '@pique/core/modules/onboarding';
import { WorkbenchService } from '@pique/core/modules/workbench';
import { useService } from '@toeverything/infra';
import { useAtom } from 'jotai';

import { appSidebarOpenAtom } from '../index.jotai';
import * as styles from './desktop-back-button.css';
import { navigateHomeAndOpenRightSidebar } from './sidebar-actions';

export const DesktopBackButton = () => {
  const workbench = useService(WorkbenchService).workbench;
  const [, setOpen] = useAtom(appSidebarOpenAtom);
  const { isRunning, currentStepId, advanceToNextStep } =
    usePostAugmentationTour();

  return (
    <div className={styles.container} data-testid="desktop-back-button" data-tauri-drag-region>
      <IconButton
        className={styles.button}
        onClick={() => {
          const shouldAdvance = isRunning && currentStepId === 'back-button';

          navigateHomeAndOpenRightSidebar({
            setOpen,
            workbench,
            delayMs: shouldAdvance ? 180 : undefined,
          });

          if (shouldAdvance) {
            const startedAt = Date.now();
            const maxWaitMs = 3500;
            const poll = () => {
              const target = document.querySelector(
                '[data-onboarding-action-group-index="0"]'
              );
              if (target || Date.now() - startedAt > maxWaitMs) {
                advanceToNextStep();
                return;
              }
              window.setTimeout(poll, 120);
            };
            window.setTimeout(poll, 200);
          }
          if (environment.isTauri) {
            import('../../../utils/window-utils').then(({ restoreWindow }) => {
              restoreWindow().catch(error => {
                console.error(
                  'Failed to restore window to normal size and position:',
                  error
                );
              });
            });
          }
        }}
        size="20"
        tooltipOptions={{ side: 'bottom' }}
        tooltip="Back"
      >
        <HugeiconsIcon
          icon={ArrowLeft02Icon}
          size={20}
          strokeWidth={1}
          color="var(--affine-text-primary-color)"
        />
      </IconButton>
    </div>
  );
};
